import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../../service/api.service';
import {BadEvent} from '../../../../class/bad-event';

@Component({
    selector: 'app-bad-event-list',
    templateUrl: './bad-event-list.component.html',
    styleUrls: ['./bad-event-list.component.css']
})
export class BadEventListComponent implements OnInit {

    badEvents: BadEvent[] = [
      {
        name:'Decesso titolari di reddito',
        description: ''
      },
      {
        name:'Invalidità permanenti',
        description: ''
      },
      {
        name:'Perdita autosufficienza',
        description: ''
      },
      {
        name:'Gravi patologie',
        description: ''
      },
      {
        name:'Perdita di lavoro',
        description: ''
      },
      {
        name:'Perdite patrimoniali',
        description: ''
      },
      {
        name:'Impatto successorio',
        description: ''
      },
    ];

    constructor(private api: ApiService) {
    }

    ngOnInit() {

    }
}
